module.exports = __webpack_public_path__ + "img/star1.8e3b9db5.png";